import {
  BeneficiaryBankAccountType,
  BeneficiaryRelationship,
  CreateBeneficiaryRequest,
  FlowType,
  PayoutContactBankAccount,
} from '../../../../store/payouts/interfaces';
import { BeneficiaryFieldValues } from './types';

const text = (values: BeneficiaryFieldValues, key: string) => String(values[key] ?? '').trim();

const getBankName = (
  bankCode: string,
  bankOptions: Array<{ code: string; name: string }>
) => bankOptions.find(bank => String(bank.code) === bankCode)?.name ?? bankCode;

export const mapFormToCreateBeneficiaryRequest = ({
  values,
  country,
  flowType,
  currency,
  bankOptions,
}: {
  values: BeneficiaryFieldValues;
  country: string;
  flowType: FlowType;
  currency: string;
  bankOptions: Array<{ code: string; name: string }>;
}): CreateBeneficiaryRequest => {
  const bankCode =
    text(values, 'beneficiary.bank_account.code') || text(values, 'beneficiary.bank_name');
  const businessName = text(values, 'beneficiary.business_name');

  return {
    flow_type: flowType,
    first_name: text(values, 'beneficiary.first_name') || businessName,
    last_name: text(values, 'beneficiary.last_name'),
    document: text(values, 'beneficiary.document.id'),
    document_type: text(values, 'beneficiary.document.type'),
    country,
    email: text(values, 'beneficiary.email'),
    phone: text(values, 'beneficiary.phone'),
    relationship:
      (text(values, 'beneficiary.relationship') as BeneficiaryRelationship) ||
      BeneficiaryRelationship.OTHER,
    bank_account: {
      country,
      currency: text(values, 'currency_to_pay') || text(values, 'beneficiary.bank_account.currency') || currency,
      bank_code: bankCode,
      bank_name: getBankName(bankCode, bankOptions),
      bank_account: text(values, 'beneficiary.bank_account.account'),
      bank_branch: text(values, 'beneficiary.bank_account.branch'),
      account_type: text(values, 'beneficiary.bank_account.type') as BeneficiaryBankAccountType,
    },
  };
};

export const mapBankAccountToFieldValues = (account: PayoutContactBankAccount): BeneficiaryFieldValues => {
  const values: BeneficiaryFieldValues = {};

  if (account.bank_code) {
    values['beneficiary.bank_account.code'] = account.bank_code;
    values['beneficiary.bank_name'] = account.bank_code;
  }
  if (account.bank_account) {
    values['beneficiary.bank_account.account'] = account.bank_account;
  }
  if (account.bank_branch) {
    values['beneficiary.bank_account.branch'] = account.bank_branch;
  }
  if (account.account_type) {
    values['beneficiary.bank_account.type'] = account.account_type;
  }
  if (account.currency) {
    values.currency_to_pay = account.currency;
    values['beneficiary.bank_account.currency'] = account.currency;
  }

  return values;
};
